import { useQuery } from "@tanstack/react-query"
import { getAreas } from "../actions/getAreas";

export const useAreasQuery = ({ categoryUid, squareFt }) => {

    const areasQuery = useQuery({
        queryKey: ["areas", categoryUid, squareFt],
        queryFn: () => getAreas({ categoryUid, squareFt }),
        // staleTime: 1000 * 60 * 60
        staleTime: 0,
    });

    return areasQuery
}